import { LabelMapper, SubscriptionType } from 'types';
import { subscriptionsTexts } from 'consts/text';

export const subscriptionTypeLabels: LabelMapper<SubscriptionType> = {
    [SubscriptionType.TESTING]: subscriptionsTexts.general.subscriptionTypes.testing,
    [SubscriptionType.ACTIVE]: subscriptionsTexts.general.subscriptionTypes.active,
    [SubscriptionType.BLOCKED]: subscriptionsTexts.general.subscriptionTypes.blocked,
    [SubscriptionType.TO_VERIFY]: subscriptionsTexts.general.subscriptionTypes.toVerify,
};
